<template>
    <div class="module">
        <a href="javascript:void(0)" class="scrollT" ref="module"></a>
        <div class="banner">
            <div class="main">
                <div class="title wow fadeInUp">DMEGC太阳能组件产品<br>可追溯性查询</div>
            </div>
        </div>
        <div class="box">
            <div class="search wow fadeInUp">
                <input type="text" v-model="cptm" placeholder="输入完整的序列号" class="text">
                <button class="btn" @click="searchCode"></button>
            </div>
            <div class="result-main">
                <a href="javascript:void(0);" class="anchor" ref="result"></a>
                <div class="result wow fadeInUp" v-if="resultFlag === 1">
                    <div class="row">
                        <div class="title">查询结果：</div>
                        <div class="list">
                            <div class="item">
                                <div class="name">产品条形码</div>
                                <div class="num">{{infoData.cptm}}</div>
                            </div>
                            <div class="item">
                                <div class="name">产品型号</div>
                                <div class="num">{{infoData.cpxh}}</div>
                            </div>
                            <div class="item">
                                <div class="name">产品功率</div>
                                <div class="num">{{infoData.cpgl}}</div>
                            </div>
                            <div class="item">
                                <div class="name">产品等级</div>
                                <div class="num">{{infoData.cpdjcn}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="dc-txt" v-if="infoData.zjscdz == null">
                        抱歉，网站上的可追湖性查询仅支持2026年1月1日之后出货的组件。<br>
                        如有任何疑问，请联系DMEGC服务团队寻求帮助。<br>
                        电话:+86-579-86310330(工作日8:30-17:00 GMT+08:00)<br>
                        邮件:service@dmegc.com.cn
                    </div>
                    <div class="row" v-else>
                        <div class="title">原产地溯源：</div>
                        <div class="list">
                            <div class="item">
                                <div class="name">模块</div>
                                <div class="num">{{infoData.zjscdz}}</div>
                            </div>
                            <div class="item">
                                <div class="name">电池片</div>
                                <div class="num">{{infoData.dcpscdz}}</div>
                            </div>
                            <div class="item">
                                <div class="name">硅片</div>
                                <div class="num">{{infoData.gpscdz}}</div>
                            </div>
                            <div class="item">
                                <div class="name">硅锭</div>
                                <div class="num">{{infoData.byscdz}}</div>
                            </div>
                            <div class="item">
                                <div class="name">多晶硅</div>
                                <div class="num">{{infoData.glcjdz}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="no-result wow fadeInUp" v-if="resultFlag === 2">
                    <div class="title">产品信息：</div>
                    <div class="icon"></div>
                    <h4>抱歉，您查询的组件信息未找到。</h4>
                    <div class="txt">
                        1.您正在查询的序列号不正确<br>
                        2.您正在查询的序列号不属于DMEGC太阳能产品<br>
                        3.您正在查询的序列号应以DM***开头<br>
                        4.自2026年1月1日之后出货的组件均可在本系统中使用。如有任何疑问，敬请<br>
                        联系您的经销商或直接联系DMEGCSolar客户服务团队。热线电话:<br>
                        +86-579-86310330或service@dmegc.com.cn，以获取帮助。<br>
                        如有任何疑问，请联系DMEGC服务团队以获取帮助。<br>
                        电话:+86-579-86310330(工作日8:30-17:00 GMT+08:00)<br>
                        邮件:service@dmegc.com.cn 
                    </div>
                    <div class="tips">如需更多信息，请联系横店东磁光伏科技客户团队。</div>
                    <a href="javascript:void" @click="resetSearch">返回<i></i></a>
                </div>
            </div>
            <div class="info wow fadeInUp">
                每个组件的序列号都是唯一的，由以下部分组成一些数字和字母，示例如下。<br>
                仅支持查询2026年1月1日之后生产的组件。
            </div>
            <div class="tel wow fadeInUp">
                如有任何疑问，请联系DMEGC服务团队寻求帮助。<br>
                <span>+ 86-579-86310330（工作日8:30-17:00，GMT+08:00）</span>或<span>service@dmegc.com.cn</span>
            </div>
            <div class="title wow fadeInUp">条形码示例图：</div>
            <div class="pic wow fadeInUp">
                <img src="../../assets/img/inquiry_pic.jpg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    import { WOW } from 'wowjs'
    import { queryInquiry } from '../../request/api'
    export default {
        name:'Module',
        metaInfo:{
            title: "组件查询-东磁光伏科技",
            meta: [{                 // set meta
                name: 'keyWords',
                content: '东磁光伏科技,可再生能源'
                }, {
                name: 'description',
                content: '全球领先的可再生能源供应商'
            }]
        },
        data(){
            return {
                cptm:'',
                infoData:{},
                msg:'',
                resultFlag: 0,
                isMobile:false,
                isLoadding: true
            }
        },
        mounted(){
            this.$nextTick(() => {

                const wow = new WOW({
                    animateClass: 'animated',
                    offset: 100
                })
                wow.init();
                this.$refs.module.scrollIntoView();
            })
        },
        methods: {
            searchCode(){

                if(this.cptm === '') {

                    alert('请输入组件条码')
                } else if (this.isLoadding){

                    this.isLoadding = false;
                    queryInquiry({cptm: this.cptm}).then(res => {

                        var data = JSON.parse(res.data);

                        console.log('data==', data);

                        if(data.code == '00000000') {        

                            console.log(1111)

                            this.resultFlag = 1
                            this.infoData = data.data
                            this.cptm = ''
                        } else {

                            console.log(2222)
                            this.resultFlag = 2
                            this.msg = data.msg
                            this.cptm = ''
                        }
                        this.isLoadding = true;
                        //this.$refs.result.scrollIntoView({behavior: "smooth"});
                    })
                }
            },
            resetSearch(){

                this.cptm = ''
                this.resultFlag = 0
                this.$refs.module.scrollIntoView({behavior:'smooth'})
            }
        }
    }
</script>

<style lang="scss" scoped>
.module{
    position: relative;
    .banner{
        height: 27.0833vw;
        background: url(../../assets/img/module_banner.jpg) no-repeat center center;
        background-size: cover;
        .main{
            height: 27.0833vw;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .title{
            font-size: 2.7083vw;
            line-height: 1.1154;
            color: #fff;
            text-align: center;
            font-weight: 300;
        }
    }
    .box{
        margin: -36px auto 0;
        width: 1124px;
        position: relative;
        z-index: 10;
        padding-bottom: 110px;
    }
    .search{
        display: flex;
        justify-content: space-between;
        .text{
            display: block;
            box-sizing: border-box;
            width: calc(100% - 82px);
            height: 72px;
            background: #F2F4F8;
            border: none;
            padding: 0 40px;
            font-size: 20px;
            color: #A4AAB6;
        }
        .btn{
            display: block;
            width: 82px;
            height: 72px;
            border: none;
            background: url(../../assets/images/search_w.png) no-repeat center center #E60011;
            background-size: 26px 26px;
        }
    }
    .info{
        text-align: center;
        font-size: 20px;
        line-height: 1.5;
        color: rgba(0, 0, 0, 0.8);
        margin-top: 30px;
    }
    .tel{
        text-align: center;
        margin: 27px 0 40px;
        font-size: 20px;
        line-height: 1.5;
        color: rgba(0, 0, 0, 0.8);
        span{
            color: #E60011;
            font-weight: bold;
        }
    }
    .title{
        font-size: 25px;
        line-height: 1.92;
        text-align: center;
        color: #000;
    }
    .pic{
        width: 451px;
        margin: 6px auto 0;
        img{
            display: block;
            width: 100%;
        }

    }
    .result-main{
        position: relative;
        margin: 30px 0 68px;
    }
    .result{
        border-bottom: 1px solid #E1E6EF;
        padding-bottom: 35px;
        .title{
            text-align: left;
        }
        .list{
            margin-top: 12px;
        }
        .row{
            &:last-child{
                margin-top: 50px;
            }
        }
        .dc-txt{
            font-size: 25px;
            line-height: 1.92;
            color: rgba(0, 0, 0, 0.6);
            margin-top: 40px;
        }
        .item{
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 90px;
            background: #F2F4F8;
            margin-bottom: 10px;
            font-size: 18px;
            color: rgba(31, 50, 67, 0.7);
            padding: 0 40px;
            line-height: 1.4;
        }
        .num{
            color: #1F3243;
            width: 330px;
        }
    }
    .no-result{
        border-bottom: 1px solid #E1E6EF;
        padding-bottom: 35px;
        .icon{
            width: 56px;
            height: 56px;
            background: url(../../assets/images/close.png) no-repeat center center #FF0000;
            background-size: 20px 20px;
            border-radius: 50%;
            margin: 30px auto 0;
        }
        h4{
            font-size: 25px;
            line-height: 1.92;
            color: #E60011;
            text-align: center;
            margin-top: 8px
        }
        .txt{
            font-size: 25px;
            line-height: 1.92;
            color: rgba(0, 0, 0, 0.6);
            margin: 48px auto 0;
            width: 880px;
        }
        .tips{
            font-size: 25px;
            line-height: 1.92;
            color: #000000;
            text-align: center;
            margin-top: 48px;
        }
        a{
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 260px;
            height: 50px;
            box-sizing: border-box;
            padding: 0 30px;
            font-size: 16px;
            color: #fff;
            background: #E60011;
            margin: 52px auto 0;
        }
        i{
            display: block;
            width: 24px;
            height: 24px;
            background: url(../../assets/images/arrowR.png) no-repeat;
            background-size: cover;
        }
    }
}
@media screen and (max-width: 750px) {
    .module{
        .banner{
            height: 5rem;
        }
        .box{
            width: 92%;
            padding-bottom: .8rem;
            margin-top: -.5rem;
        }
        .search{
            .text{
                width: calc(100% - 1.2rem);
                height: 1rem;
                padding: 0 .3rem;
                font-size: .28rem;
            }
            .btn{
                width: 1.2rem;
                height: 1rem;
                background-size: .52rem .52rem;
            }
        }
        .info{
            font-size: .26rem;
            margin-top: .6rem;
        }
        .tel{
            font-size: .28rem;
            margin: .4rem 0 .6rem;
        }
        .title{
            font-size: .36rem;
        }
        .dc-txt{
            font-size: .26rem;
            margin-top: .4rem;
        }
        .row{
            &:last-child{
                margin-top: .5rem;
            }
        }
        .pic{
            width: 4.5rem;
            margin-top: .2rem;
        }
        .result-main{
            margin: .4rem 0 .8rem;
        }
        .result{
            padding-bottom: .6rem;
            .list{
                margin-top: .2rem;
            }
            .item{
                height: 1rem;
                margin-bottom: .2rem;
                padding: 0 .3rem;
                font-size: .28rem;
            }
            .num{
               width: 5.2rem;
            }
        }
        .no-result{
            padding-bottom: .6rem;
            .icon{
                width: 1.12rem;
                height: 1.12rem;
                background-size: .4rem .4rem;
                margin-top: .6rem;
            }
            h4{
                font-size: .36rem;
                margin-top: .3rem;
            }
            .txt,.tips{
                font-size: .36rem;
                width: 100%;
                margin-top: .6rem;
            }
            a{
                width: 4.2rem;
                height: .8rem;
                font-size: .3rem;
                padding: 0 .6rem;
                margin-top: .6rem;
            }
            i{
                width: .48rem;
                height: .48rem;
            }
        }
    }
}
</style>